import React, { Component } from 'react';
import { Card, Media, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EmpresaStatus from './EmpresaStatus';
import EmpresaTenancyStatus from './EmpresaTenancyStatus';

class SwitchEmpresaListItem extends Component {

  handleOnClick = () => {
    const { data } = this.props;

    this.props.onClick(data);
  }

  render() {
    const { data } = this.props;

    return (

      <Card onClick={ this.handleOnClick } className="my-3">
        <Card.Body>
          <Media className="py-0 px-0">
            <Media.Body>
              <h6 className="text-muted card-subtitle h6">
                <FontAwesomeIcon className="icon icon-25" icon={ ['far', 'building'] } />
                  { '  ' } { data.nombre }
              </h6>

              <p></p>

              <Row className="mt-4">
                <Col>
                  <EmpresaStatus data={ data } /> { '  ' } <EmpresaTenancyStatus data={ data } />
                </Col>

                <Col className="text-right">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        Hits disponibles
                      </Tooltip>
                    }
                  >
                    <div className="float-right">
                      { data.hits > 0 && <span>{ data.hits }+</span> }
                      { data.hits <= 0  && <span>0 Hits</span> }
                    </div>
                  </OverlayTrigger>
                </Col>
              </Row>

            </Media.Body>
          </Media>
        </Card.Body>
      </Card>
    )
  }
}

export default SwitchEmpresaListItem;